import script from "./GameIntroPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./GameIntroPanel.vue?vue&type=script&setup=true&lang=js"

import "./GameIntroPanel.vue?vue&type=style&index=0&id=3bd2f737&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bd2f737"]])

export default __exports__